import type React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import './TermsOfService.css';

interface TermSection {
  title: string;
  content?: string;
  list?: string[];
  footer?: string;
}

const TermsOfService: React.FC = () => {
  const { t } = useTranslation();

  const sections = t('terms.sections', { returnObjects: true }) as TermSection[];

  return (
    <div className="terms-page">
      <div className="bg-accent-shape" />
      <Header />

      <main className="terms-main">
        <section className="terms-hero">
          <div className="terms-hero-content">
            <div className="hero-line" />
            <h2 className="hero-label">{t('terms.heroLabel', 'Legal')}</h2>
            <div className="hero-line" />
          </div>
          <h1 className="hero-title">{t('terms.title', 'Terms of Service')}</h1>
          <p className="terms-last-updated">{t('terms.lastUpdated', 'Last Updated: 01.01.2026')}</p>
        </section>

        <section className="terms-content">
          <div className="terms-intro">
            {t('terms.intro', 'Welcome to TheyChat.')
              .split('\n')
              .map((paragraph) => (
                <p key={`intro-${paragraph.slice(0, 20)}`}>{paragraph}</p>
              ))}
          </div>

          {Array.isArray(sections) &&
            sections.map((section, index) => (
              <div className="terms-section" key={`section-${index}-${section.title}`}>
                <h2>{section.title}</h2>
                {section.content && (
                  <div className="terms-section-content">
                    {section.content.split('\n').map((paragraph, pIndex) => (
                      <p key={`term-content-${index}-${pIndex}-${paragraph.slice(0, 10)}`}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                )}
                {section.list && (
                  <ul className="terms-list">
                    {section.list.map((item, itemIndex) => (
                      <li key={`term-item-${index}-${itemIndex}-${item.slice(0, 10)}`}>{item}</li>
                    ))}
                  </ul>
                )}
                {section.footer && (
                  <div className="terms-section-footer">
                    {section.footer.split('\n').map((paragraph, pIndex) => (
                      <p key={`term-footer-${index}-${pIndex}-${paragraph.slice(0, 10)}`}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            ))}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
